module.exports = __webpack_public_path__ + "img/connect-2-zh.f8055a4c.png";